import * as colors from '@atlaskit/theme/colors';
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const fadedB75 = 'rgba(179, 212, 255, 0.6)';
const values = {
  // Default appearance
  background: {
    default: {
      default: {
        light: `var(--ds-background-neutral, ${colors.N20A})`,
        dark: `var(--ds-background-neutral, ${colors.DN70})`
      },
      hover: {
        light: `var(--ds-background-neutral-hovered, ${colors.N30A})`,
        dark: `var(--ds-background-neutral-hovered, ${colors.DN60})`
      },
      active: {
        light: `var(--ds-background-neutral-pressed, ${fadedB75})`,
        dark: `var(--ds-background-neutral-pressed, ${colors.B75})`
      },
      disabled: {
        light: `var(--ds-background-disabled, ${colors.N20A})`,
        dark: `var(--ds-background-disabled, ${colors.DN70})`
      },
      selected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.DN0})`
      },
      focusSelected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.DN0})`
      }
    },
    primary: {
      default: {
        light: `var(--ds-background-brand-bold, ${colors.B400})`,
        dark: `var(--ds-background-brand-bold, ${colors.B100})`
      },
      hover: {
        light: `var(--ds-background-brand-bold-hovered, ${colors.B300})`,
        dark: `var(--ds-background-brand-bold-hovered, ${colors.B75})`
      },
      active: {
        light: `var(--ds-background-brand-bold-pressed, ${colors.B500})`,
        dark: `var(--ds-background-brand-bold-pressed, ${colors.B200})`
      },
      disabled: {
        light: `var(--ds-background-disabled, ${colors.N20A})`,
        dark: `var(--ds-background-disabled, ${colors.DN70})`
      },
      selected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.DN0})`
      },
      focusSelected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.DN0})`
      }
    },
    warning: {
      default: {
        light: `var(--ds-background-warning-bold, ${colors.Y300})`,
        dark: `var(--ds-background-warning-bold, ${colors.Y300})`
      },
      hover: {
        light: `var(--ds-background-warning-bold-hovered, ${colors.Y200})`,
        dark: `var(--ds-background-warning-bold-hovered, ${colors.Y200})`
      },
      active: {
        light: `var(--ds-background-warning-bold-pressed, ${colors.Y400})`,
        dark: `var(--ds-background-warning-bold-pressed, ${colors.Y400})`
      },
      disabled: {
        light: `var(--ds-background-disabled, ${colors.N20A})`,
        dark: `var(--ds-background-disabled, ${colors.DN70})`
      },
      selected: {
        light: `var(--ds-background-selected, ${colors.Y400})`,
        dark: `var(--ds-background-selected, ${colors.Y400})`
      },
      focusSelected: {
        light: `var(--ds-background-selected, ${colors.Y400})`,
        dark: `var(--ds-background-selected, ${colors.Y400})`
      }
    },
    danger: {
      default: {
        light: `var(--ds-background-danger-bold, ${colors.R400})`,
        dark: `var(--ds-background-danger-bold, ${colors.R400})`
      },
      hover: {
        light: `var(--ds-background-danger-bold-hovered, ${colors.R300})`,
        dark: `var(--ds-background-danger-bold-hovered, ${colors.R300})`
      },
      active: {
        light: `var(--ds-background-danger-bold-pressed, ${colors.R500})`,
        dark: `var(--ds-background-danger-bold-pressed, ${colors.R500})`
      },
      disabled: {
        light: `var(--ds-background-disabled, ${colors.N20A})`,
        dark: `var(--ds-background-disabled, ${colors.DN70})`
      },
      selected: {
        light: `var(--ds-background-selected, ${colors.R500})`,
        dark: `var(--ds-background-selected, ${colors.R500})`
      },
      focusSelected: {
        light: `var(--ds-background-selected, ${colors.R500})`,
        dark: `var(--ds-background-selected, ${colors.R500})`
      }
    },
    link: {
      default: {
        light: "var(--ds-background-neutral-subtle, none)",
        dark: "var(--ds-background-neutral-subtle, none)"
      },
      selected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.N20})`
      },
      focusSelected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.N20})`
      }
    },
    subtle: {
      default: {
        light: "var(--ds-background-neutral-subtle, none)",
        dark: "var(--ds-background-neutral-subtle, none)"
      },
      hover: {
        light: `var(--ds-background-neutral-subtle-hovered, ${colors.N30A})`,
        dark: `var(--ds-background-neutral-subtle-hovered, ${colors.DN60})`
      },
      active: {
        light: `var(--ds-background-neutral-subtle-pressed, ${fadedB75})`,
        dark: `var(--ds-background-neutral-subtle-pressed, ${colors.B75})`
      },
      disabled: {
        light: "var(--ds-background-neutral-subtle, none)",
        dark: "var(--ds-background-neutral-subtle, none)"
      },
      selected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.DN0})`
      },
      focusSelected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.DN0})`
      }
    },
    'subtle-link': {
      default: {
        light: "var(--ds-background-neutral-subtle, none)",
        dark: "var(--ds-background-neutral-subtle, none)"
      },
      selected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.N20})`
      },
      focusSelected: {
        light: `var(--ds-background-selected, ${colors.N700})`,
        dark: `var(--ds-background-selected, ${colors.N20})`
      }
    }
  },
  color: {
    default: {
      default: {
        light: `var(--ds-text, ${colors.N500})`,
        dark: `var(--ds-text, ${colors.DN400})`
      },
      active: {
        light: `var(--ds-text, ${colors.B400})`,
        dark: `var(--ds-text, ${colors.B400})`
      },
      disabled: {
        light: `var(--ds-text-disabled, ${colors.N70})`,
        dark: `var(--ds-text-disabled, ${colors.DN30})`
      },
      selected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      },
      focusSelected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      }
    },
    primary: {
      default: {
        light: `var(--ds-text-inverse, ${colors.N0})`,
        dark: `var(--ds-text-inverse, ${colors.DN30})`
      },
      disabled: {
        light: `var(--ds-text-disabled, ${colors.N70})`,
        dark: `var(--ds-text-disabled, ${colors.DN30})`
      },
      selected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      },
      focusSelected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      }
    },
    warning: {
      default: {
        light: `var(--ds-text-warning-inverse, ${colors.N800})`,
        dark: `var(--ds-text-warning-inverse, ${colors.N800})`
      },
      disabled: {
        light: `var(--ds-text-disabled, ${colors.N70})`,
        dark: `var(--ds-text-disabled, ${colors.DN30})`
      },
      selected: {
        light: `var(--ds-text-selected, ${colors.N800})`,
        dark: `var(--ds-text-selected, ${colors.N800})`
      },
      focusSelected: {
        light: `var(--ds-text-selected, ${colors.N800})`,
        dark: `var(--ds-text-selected, ${colors.N800})`
      }
    },
    danger: {
      default: {
        light: `var(--ds-text-inverse, ${colors.N0})`,
        dark: `var(--ds-text-inverse, ${colors.N0})`
      },
      disabled: {
        light: `var(--ds-text-disabled, ${colors.N70})`,
        dark: `var(--ds-text-disabled, ${colors.DN30})`
      },
      selected: {
        light: `var(--ds-text-selected, ${colors.N0})`,
        dark: `var(--ds-text-selected, ${colors.N0})`
      },
      focusSelected: {
        light: `var(--ds-text-selected, ${colors.N0})`,
        dark: `var(--ds-text-selected, ${colors.N0})`
      }
    },
    link: {
      default: {
        light: `var(--ds-link, ${colors.B400})`,
        dark: `var(--ds-link, ${colors.B100})`
      },
      hover: {
        light: `var(--ds-link, ${colors.B300})`,
        dark: `var(--ds-link, ${colors.B75})`
      },
      active: {
        light: `var(--ds-link-pressed, ${colors.B500})`,
        dark: `var(--ds-link-pressed, ${colors.B200})`
      },
      disabled: {
        light: `var(--ds-text-disabled, ${colors.N70})`,
        dark: `var(--ds-text-disabled, ${colors.DN100})`
      },
      selected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.N700})`
      },
      focusSelected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.N700})`
      }
    },
    subtle: {
      default: {
        light: `var(--ds-text, ${colors.N500})`,
        dark: `var(--ds-text, ${colors.DN400})`
      },
      active: {
        light: `var(--ds-text, ${colors.B400})`,
        dark: `var(--ds-text, ${colors.B400})`
      },
      disabled: {
        light: `var(--ds-text-disabled, ${colors.N70})`,
        dark: `var(--ds-text-disabled, ${colors.DN100})`
      },
      selected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      },
      focusSelected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      }
    },
    'subtle-link': {
      default: {
        light: `var(--ds-text-subtle, ${colors.N200})`,
        dark: `var(--ds-text-subtle, ${colors.DN400})`
      },
      hover: {
        light: `var(--ds-text-subtle, ${colors.N90})`,
        dark: `var(--ds-text-subtle, ${colors.B50})`
      },
      active: {
        light: `var(--ds-text, ${colors.N400})`,
        dark: `var(--ds-text, ${colors.DN300})`
      },
      disabled: {
        light: `var(--ds-text-disabled, ${colors.N70})`,
        dark: `var(--ds-text-disabled, ${colors.DN100})`
      },
      selected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      },
      focusSelected: {
        light: `var(--ds-text-selected, ${colors.N20})`,
        dark: `var(--ds-text-selected, ${colors.DN400})`
      }
    }
  }
};
export default values;